/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

const MS_CLIENT_ID = 'a81c9c16-bf71-4f3e-a663-4666107cb355'

export const msalConfig = {
  auth: {
    clientId: MS_CLIENT_ID,
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 *
 * No `prompt` — Microsoft round-trips silently when there is a single active session
 * and only shows UI (account picker / login) when it's actually needed. Used for the
 * automatic flows (silent SSO, Safari/Firefox auto-redirect, /azuresso deep link).
 */
export const loginRequest = {
  scopes: ['User.Read']
}

/**
 * For the explicit "login with microsoft" button — always show the account picker
 * so the user can pick / switch accounts even if a session is already active.
 */
export const selectAccountRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account'
}

/**
 * Request used for the silent (no-UI) SSO attempt on the login page.
 * No `prompt` — silent flows must never ask for interaction.
 */
export const silentRequest = {
  scopes: ['User.Read']
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
}
